export function convertToSingleValue<T>(input?: T | T[]): T | undefined {
  if (Array.isArray(input) && input.length > 0) {
    return input[0];
  }
  return input as T | undefined;
}
